import { APIBoxForm } from 'components/panels/APIBoxForm';
import { SlidePanel } from 'components/utils/panels/AvoSlidePanel';
import { Body2, H4 } from 'components/utils/typo';
import 'css/custom.css';
import { useContext, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { UIElement } from '../../../api/moduleElement';
import { MODULE_TYPES } from '../../../constants';
import { useTriggers } from '../../../hooks/module/resources/useTriggers';
import { ModuleContext } from '../../utils/module/ModuleContext';
import { DraggableContext, ModuleElementContext } from '../ModuleBoard';
import { GroupCardContext } from './GroupCard';
import { CardContainer } from './utils/CardContainer';

interface APIBoxCardProps {
  element: UIElement;
}

export interface APIBoxFormVariable {
  trigger: number;
  title: string;
  container?: number;
  position: number;
  variable: string;
  module?: number;
  calculator?: number;
  api_resource: number;
  is_hide: boolean;
}

// TODO: it has issues related group card, variable
export const APIBoxCard = ({ element }: APIBoxCardProps) => {
  const { module } = useContext(ModuleContext);
  const { setIsDragDisabled } = useContext(DraggableContext);

  const { groupCardId, isInsideGroupCard } = useContext(GroupCardContext);
  const { refetchModuleElements, deleteUIElement, clearModuleElements } =
    useContext(ModuleElementContext);
  const [formOpen, setFormOpen] = useState(!element.id);
  useEffect(() => setIsDragDisabled(formOpen), [formOpen]);

  const { data: triggers } = useTriggers();
  const alwayOnTrigger = triggers.find((data) => data.title === 'Always On');

  const defaultValues: APIBoxFormVariable = {
    module: module?.type === MODULE_TYPES.ALGO ? module.id : undefined,
    calculator: module?.type === MODULE_TYPES.CALCULATOR ? module.id : undefined,
    trigger: element.trigger?.id ?? alwayOnTrigger?.id,
    title: element.title ?? '',
    variable: element.variable_item?.name ?? '',
    container: groupCardId,
    position: element.position,
    api_resource: element.api_resource?.id ?? undefined,
    is_hide: element.is_hide ?? false,
  };

  const form = useForm<APIBoxFormVariable>({ defaultValues });
  const onCancel = () => {
    clearModuleElements();
    form.reset(defaultValues);
    setFormOpen(false);
  };

  const onSave = () => {
    try {
      refetchModuleElements();
      setFormOpen(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <FormProvider {...form}>
      <CardContainer
        elementId={element.id}
        onOpenPanel={() => setFormOpen(true)}
        isPreviewing={formOpen}
        variables={[{ type: 'API', name: form.watch('variable') }]}
      >
        <H4 className='text-gray-900'>{form.watch('title')}</H4>
        {element?.api_resource?.title && (
          <Body2 className='text-gray-900'>
            <b>API Resource: </b>
            {element?.api_resource?.title}
          </Body2>
        )}
      </CardContainer>

      <SlidePanel open={formOpen}>
        <APIBoxForm apiBoxId={element.id} onSave={onSave} onCancel={onCancel} />
      </SlidePanel>
    </FormProvider>
  );
};
